export function PipeRule({ label }: { label?: string }) {
  return (
    <div className="row" style={{ gap: 14, alignItems: 'center', color: 'var(--fg-3)' }}>
      <span className="pipe-rule" style={{ flex: 1 }}>{'─'.repeat(40)}</span>
      {label && <span className="eyebrow">{label}</span>}
      <span className="pipe-rule" style={{ flex: 1 }}>{'─'.repeat(40)}</span>
    </div>
  )
}
